function ListFilter(props) {
	return (
		<div className="row d-flex col-12 classificacao mb-2">
			<div className="col-12 ms-3">
				<div>{props.nome ? <small>{`Nome: ${props.nome}`}</small> : null}</div>
				{props.tipoData ? <small className="d-block">{`Opção selecionada: ${props.tipoData}`}</small> : null}
				{props.dtini && <small>{`Data: ${props.dtini} e ${props.dtfim}`}</small>}
				{props.atrasados ? <small>{` - Somente à receber`}</small> : null}
				<div className="d-block">
					{props.count > 0 && <small>{`Registros Encontrados ${props.count}`}</small>}

					{props.count > 0 && props.valortotal > 0 && (
						<small>
							<b>{` - Total R$ ${props.valortotal}`}</b>
						</small>
					)}
				</div>
			</div>
		</div>
	);
}

export default ListFilter;
